import axios from "axios";
import beveatApiResourceOwner from "../../../api/resource_owner_beveat_api.js";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { commonConfigs, urls } from "../../../../config.js";
import ProjectDetailsCard from '../../components/project_details_card.jsx';

const ProjectDetailsBloc = () => {
  const location = useLocation();
  const { developerSsoId, developerProjId, projectIndex, invoicePlanSyscode } = location.state || {};
  const [load, setLoad] = useState(true);
  const [data, setData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const devProjTableSyscode = invoicePlanSyscode;
  let getOneProjectUrl = `${urls.resourceOwnerUrl}${commonConfigs.apiUrls.GetOneDeveloperProjects(developerSsoId, developerProjId, devProjTableSyscode)}`;

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  async function getProject() {
    await beveatApiResourceOwner
      .get(getOneProjectUrl, { headers: commonConfigs.apiHeader })
      .then((res) => {
        // console.log(res.data.result.data);
        setData(res.data.result.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      })
  }

  useEffect(() => {
    getProject();
  }, []);

  if (!load) {
    return (
      <div className={`${isMobile ? 'p-4' : ''}`}>
        <div className={`${isMobile ? 'mt-2 space-y-4' : 'mt-4 desktop:space-x-8 mobile:pt-2 mobile:pb-4 mobile:space-x-2'}`}>
          {/* calling the ProjectDetailsCard component */}
          <div 
            className={`${isMobile ? 'mt-8 flex flex-col gap-4 px-2' : 'mt-16 flex flex-grow gap-x-1 justify-end pr-10'}`}
            style={!isMobile ? { 
              display: 'grid', 
              gridTemplateColumns: '2fr 2fr 2fr' 
            } : {}}
          >
            <ProjectDetailsCard 
              data={data} 
              index={projectIndex} 
              invoicePlanSyscode={invoicePlanSyscode} 
              isMobile={isMobile} 
              type="community"
            />
          </div>
        </div>
      </div>
    );
  }

  // Mobile-friendly loading state
  return (
    <div className={`${isMobile ? 'p-4' : ''} min-h-screen flex items-center justify-center`}>
      <div className="text-center">
        <div className={`animate-spin rounded-full border-4 border-blue-200 border-t-blue-600 mx-auto mb-4 ${
          isMobile ? 'h-12 w-12' : 'h-16 w-16'
        }`}></div>
        <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
          Loading Project Details
        </h3>
        <p className={`text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
          Please wait while we fetch the project information...
        </p>
      </div>
    </div>
  );
};

export default ProjectDetailsBloc;